import { render } from "./mobile-money-ghana.vue?vue&type=template&id=5a35441d"
import script from "./mobile-money-ghana.vue?vue&type=script&lang=js"
export * from "./mobile-money-ghana.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__